import { Expose, Transform } from "class-transformer";
import { BaseModel } from "src/shared/models/base.model";
import { DocumentsDownloadTypes } from "src/containers/documents-download/constants/document-types";

export class Document extends BaseModel {
    @Expose()
    id = "";
    @Expose()
    creationDate = "";
    @Expose()
    fileName = "";
    @Expose()
    @Transform((data) => data.value ?? "PÓLIZA")
    documentType = "";

    get isEndorsement() {
        return (
            this.documentType.toLowerCase() ===
            DocumentsDownloadTypes.Endorsement.toLowerCase()
        );
    }
}
